import { getDaysBetweenDates } from 'components/shared/processes'
import moment from 'moment'
import { useCallback, useMemo, useState } from 'react'

export const useDateRangeFilter = () => {
	const [dateRange, setDateRange] = useState({
		startDate: moment().startOf('day').valueOf(),
		endDate: moment().endOf('day').valueOf(),
	})

	const onChangeCallback = useCallback(value => {
		setDateRange({
			startDate: value[0],
			endDate: value[1],
		})
	}, [])

	const daysBetweenDates = useMemo(() => {
		return getDaysBetweenDates(dateRange)
	}, [dateRange])

	return {
		dateRange,
		onChangeCallback,
		daysBetweenDates,
	}
}
